export function getSortCodeFromURL(url) {
  const urlObject = new URL(url);
  const pathComponents = urlObject.pathname.split("/");
  return pathComponents[pathComponents.length - 1];
}
